import {
  CompositeFilterDescriptor,
  SortDescriptor,
} from '@progress/kendo-data-query'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

interface MatrizConfigState {
  filter?: CompositeFilterDescriptor
  sort?: SortDescriptor[]
}

const initialState: MatrizConfigState = {}

const matrizConfigSlice = createSlice({
  name: 'matrizConfig',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{ value?: CompositeFilterDescriptor }>,
    ) => {
      state.filter = action.payload.value
    },
    setSort: (state, action: PayloadAction<{ value?: SortDescriptor[] }>) => {
      state.sort = action.payload.value
    },
  },
})

export const { setFilter, setSort } = matrizConfigSlice.actions

const MatrizConfigReducer = matrizConfigSlice.reducer

export default MatrizConfigReducer
